module.exports = __webpack_public_path__ + "img/icon (10).01fc9caa.png";